import { createStore } from 'vuex'

export default createStore({
  state: {
    menu_open : false,
    apiUrl : "https://api.safegrp.com/api",
    assetsUrl : "https://api.safegrp.com/",
    // apiUrl : "http://localhost:8080/api",
    // assetsUrl : "http://localhost:8080/",
  },
  mutations: {
    closeMenu(state) {
      state.menu_open = false;
    }
  },
  actions: {
  },
  modules: {
  }
})
